import * as Yup from "yup";

export class MicrojobAdvancedSearchForm {
	title: string | null = null

	public toRequest(): any {
		let result: any = {
			title: this.title
		}

		if (result.title === "") {
			result.title = null
		}

		return result
	}
}

const MicrojobAdvancedSearchValidation = {
}

export default Yup.object()
	.shape(
		MicrojobAdvancedSearchValidation,
	)
	.required()
